import { SVGProps, Ref, forwardRef } from 'react';

export const FolderHyperstarOutlinedSize24Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <g>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M12.3 4h3.2c4.61 0 6.521 1.35 6.919 5.231 1.218.68 1.69 1.875 1.56 3.769h-1.806c.098-1.17-.095-1.682-.282-1.916-.261-.325-1.052-.784-3.584-.784H5.694c-2.533 0-3.323.459-3.584.784-.263.329-.54 1.21.001 3.698.522 2.397 1.156 3.628 1.948 4.32.758.663 1.972 1.098 4.341 1.098H15V22H8.4c-5.093 0-6.962-1.838-8.048-6.836-.683-3.138-.41-4.962 1.148-5.886V9c0-5.25 1.75-7 7-7h3zm-3.8-.2c-2.525 0-3.636.444-4.196 1.004-.535.535-.964 1.574-1.001 3.868.68-.118 1.475-.172 2.391-.172h12.613c.836 0 1.571.045 2.21.143-.18-.95-.479-1.497-.82-1.84-.56-.56-1.672-1.003-4.197-1.003h-4.419l-.8-2z"
                        fill="currentColor"
                    />
                    <path
                        d="M20.5 15a13.3 13.3 0 0 0 3.5 3.5 13.3 13.3 0 0 0-3.5 3.5 13.3 13.3 0 0 0-3.5-3.5 13.3 13.3 0 0 0 3.5-3.5"
                        fill="currentColor"
                    />
                </g>
            </g>
        </svg>
    )
);
FolderHyperstarOutlinedSize24Glyph.displayName = 'FolderHyperstarOutlinedSize24Glyph';
